// Scoped to one browser document. A session transfer performs a full navigation, which replaces
// the document and re-evaluates this module, so the flag starts false again on the page the user
// lands on. A client-side route change does NOT reset it — fine here, because the flag is only
// ever set in the moments between committing to loginWithRedirect and the browser leaving.
//
// Deliberately not in SessionTransfer.utils.ts: the server imports that file (handleRedirects →
// lib/sessionTransfer), where module state would be shared by every request the process handles
// rather than scoped to one visitor.
let sessionTransferInFlight = false;

export const markSessionTransferInFlight = (): void => {
  sessionTransferInFlight = true;
};

export const clearSessionTransferInFlight = (): void => {
  sessionTransferInFlight = false;
};

export const isSessionTransferInFlight = (): boolean => sessionTransferInFlight;
